module.exports = __webpack_public_path__ + "img/pay-cupo.89237677.svg";